<div class="review-dialog">
  <div class="ui-g-12 p-zero dialog-header">
    <div class="send-dialog-heading">Send {{title}}</div>
    <i class="fal fa-times fa-sm dialog-close" (click)="close({})"></i>
  </div>

  <div class="ui-g-12 p-zero dialog-body">
    <div class="row p-zero">
      <div class="col-12 col-lg-{{isMarketingEnabled? '4': '6'}}">
        <div class="left-box">
          <div *ngIf="!isReviewRequestOnly" class="review-switch-wrapper">
            <div class="ml-m5px">
              <app-switch-pill label="Reviews" position="end" id="payment-review" [disabled]="!data._id"
                [isActive]="reviewAttach" (appChange)="onChange('reviewAttach', $event)">
              </app-switch-pill>
            </div>

            <div *ngIf="data._id" class="ml-2" tooltipPosition="right" [pTooltip]="!paymentId ? 'Receipt unavailable' : 'Send Recipt'">
              <app-switch-pill label="Receipt" position="end" id="review-reciept" [disabled]="!data._id || !paymentId"
                [isActive]="receiptAttach" (appChange)="onChange('receiptAttach', $event)">
              </app-switch-pill>
            </div>
          </div>

          <div class="mt-2">
            <p class="mb-1 font-600">Customer*</p>

            <div class="recipient" *ngIf="!customerLableVisible">
              <app-auto-complete placeholder="Search customer" theme="border" id="review-search-customer"
                leftIcon="fal fa-user" scrollHeight="192px" listId="review-search-customer-list" [fontSize]="12"
                [autoFocus]="true" [suggestions]="customerSearchResults" [closeOnSelection]="true"
                [value]="customerSearchKey" [disabled]="!acNotDisable.customer" [hasSearchIcon]="true"
                (appSelect)="onSearchSelect($event)" (appCompletedMethod)="customerSearch($event)"
                (appClear)="onSearchClear()">
                <ng-template let-item appTemplate="item">
                  <span class="search-item" [ngClass]="{'disabled': !item?.isActive}"
                    (click)="!item?.isActive? $event.stopPropagation() : null">
                    <div class="data-box" [ngClass]="{'disabled': !item?.isActive}">
                      <b>{{item.fullNameQBO}}</b>
                      <br>
                      {{item.phone | mask: '(000) 000-0000'}} {{ (item.email && item.phone) ? '-' : ''}}
                      {{item.email}}
                    </div>
                  </span>
                </ng-template>
              </app-auto-complete>
              <div class="globe-icon" (click)="switchLanguage()" *ngIf="companyLocalization">
                {{currentLang?.toUpperCase()}}
                <i class="fa fa-globe fa-globe" aria-hidden="true"></i>
              </div>
            </div>

            <div class="selected-customer flex-start-center" *ngIf="customerLableVisible">
              <div class="icon-wrapper flex-center-center">
                <i class="fal fa-user m-0"></i>
              </div>

              <div class="customer-wrapper">
                <div class="customer-name text-ellipse">
                  {{customer.fullName}}
                </div>
              </div>

              <div class="globe-icon-selector flex-start-center gap-2">
                <span (click)="switchLanguage()" *ngIf="companyLocalization">
                  {{currentLang?.toUpperCase()}}
                  <i class="fa fa-globe fa-globe" aria-hidden="true"></i>
                </span>
                <i *ngIf="acNotDisable.customer" id="review-close-dialog" class="fal fa-times"
                  (click)="onSearchClear()"></i>
              </div>

            </div>
          </div>

          <div class="mt-2">
            <p class="mb-1 font-600">Subject*</p>
            <div class="subject">
              <input id="review-subject" type="text" placeholder="Subject" [(ngModel)]="subject" class="font-13">
            </div>
          </div>

          <div class="mt-2">
            <p class="mb-1 font-600">Message*</p>
            <div class="message">
              <textarea id="review-message" name="" cols="30" [(ngModel)]="content" rows="5" placeholder="Message"
                class="font-13"></textarea>
            </div>
          </div>

        </div>
      </div>

      <div class="col-12 col-lg-{{isMarketingEnabled? '4': '6'}}">
        <div class="right-box">
          <!-- Contact preferrence -->
          <div *ngIf="customer && customer.customerId">
            <div class="contact-btn d-flex">
              <app-outline-icon-btn [id]="'review-btn-email-selected'" class="mr-2" [disabled]="!customer?.email"
                [active]="isEmailSelected" (handleClick)="toggleActiveState('isEmailSelected', $event)" label="Email"
                icon="fal fa-envelope">
              </app-outline-icon-btn>
              <app-outline-icon-btn [id]="'review-btn-sms-selected'" class="ml-2p" [disabled]="!customer?.phone"
                [active]="isSMSSelected" (handleClick)="toggleActiveState('isSMSSelected', $event)" label="SMS"
                icon="fal fa-mobile">
              </app-outline-icon-btn>
            </div>
          </div>

          <!-- Notifications -->
          <div *ngIf="customer && customer.customerId"
            class="notification-contact-box flex-column flex-center-start mt-2 position-relative"
            tooltipStyleClass="ticket-tooltip modifier apt-tooltip completed" tooltipPosition="right"
            [pTooltip]="notificationRecipientTooltip" [escape]="false">
            <i class="far fa-edit pointer p-2 update-recipient-icon" tooltipPosition="top"
              [ngClass]="{'not-allowed': !isEmailSelected && !isSMSSelected}"
              [pTooltip]="!isEmailSelected && !isSMSSelected? 'Select Email or Phone to add Recipients': ''"
              (click)="openUpdateRecipientDialog('confirmation')"></i>

            <div class="width-100p flex-start-center">
              <i class="fal fa-bell font-gray-85 contact-icon flex-center-center"></i>
              <span class="font-bold">Notification</span>
            </div>

            <div class="flex-start-center font-13">
              <i class="fal fa-envelope font-gray-85 contact-icon flex-center-center"></i>
              <span *ngIf="recipients?.emails?.length === 1 ">
                {{recipients?.emails[0].value}}
              </span>

              <span *ngIf="recipients?.emails?.length !== 1">
                <span *ngIf="!recipients?.emails?.length">No email</span>
                <span *ngIf="recipients?.emails?.length">{{recipients?.emails?.length}} email addresses</span>
              </span>
            </div>

            <div class="flex-start-center font-13">
              <i class="fal fa-mobile font-gray-85 contact-icon flex-center-center"></i>
              <span *ngIf="recipients?.phones?.length === 1">
                {{recipients?.phones[0].value| mask: '(000) 000-0000'}}
              </span>

              <span *ngIf="recipients?.phones?.length !== 1">
                <span *ngIf="!recipients?.phones?.length">No phone</span>
                <span *ngIf="recipients?.phones?.length">{{recipients?.phones?.length}} mobile numbers</span>
              </span>
            </div>
          </div>

          <!-- Reminder -->
          <div *ngIf="customer && customer.customerId  && reviewAttach"
            class="notification-contact-box flex-column flex-center-start mt-2 position-relative"
            tooltipStyleClass="ticket-tooltip modifier apt-tooltip completed" tooltipPosition="right"
            [pTooltip]="reminderRecipientTooltip" [escape]="false">
            <i class="far fa-edit pointer p-2 update-recipient-icon reminder" tooltipPosition="top"
              [ngClass]="{'not-allowed': !isEmailSelected && !isSMSSelected}"
              [pTooltip]="!isEmailSelected && !isSMSSelected? 'Select Email or Phone to add Recipients': ''"
              (click)="openUpdateRecipientDialog('reminder')"></i>

            <div class="width-100p flex-between-center">
              <div class="flex-start-center">
                <i class="fal fa-chevron-right font-gray-85 contact-icon flex-center-center"></i>
                <span class="font-bold">
                  Reminder
                  <i *ngIf="unsubscriptionTooltip" class="fal fa-exclamation-triangle font-yellow font-13"
                    tooltipPosition="top" [escape]="false" [pTooltip]="unsubscriptionTooltip"></i>
                </span>
              </div>


              <app-switch-pill [isActive]="card.reminders.switch && !isReminderDisabled" [disabled]="isReminderDisabled"
                (appChange)="handleReminderEnableChange($event)">
              </app-switch-pill>
            </div>

            <div class="flex-start-start">
              <app-checkbox label="" [fontSize]="11" [isChecked]="useConfirmationRecipient"
                (appChange)="useConfirmationRecipient = $event">
              </app-checkbox>

              <p class="m-0 font-11">Send reminders to same contacts as confirmation</p>
            </div>

            <div class="flex-start-center font-13">
              <i class="fal fa-envelope font-gray-85 contact-icon flex-center-center"></i>
              <span *ngIf="reminderRecipients?.emails?.length === 1">
                {{reminderRecipients?.emails[0].value}}
              </span>

              <span *ngIf="reminderRecipients?.emails?.length !== 1">
                <span *ngIf=" !reminderRecipients?.emails?.length">No email</span>
                <span *ngIf="reminderRecipients?.emails?.length">
                  {{reminderRecipients?.emails?.length}} email addresses
                </span>
              </span>
            </div>

            <div class="flex-start-center font-13">
              <i class="fal fa-mobile font-gray-85 contact-icon flex-center-center"></i>
              <span *ngIf="reminderRecipients?.phones?.length === 1">
                {{reminderRecipients?.phones[0].value| mask: '(000) 000-0000'}}
              </span>

              <span *ngIf="reminderRecipients?.phones?.length !== 1">
                <span *ngIf="!reminderRecipients?.phones?.length">No phone</span>
                <span *ngIf="reminderRecipients?.phones?.length">
                  {{reminderRecipients?.phones?.length}} mobile numbers
                </span>
              </span>
            </div>

            <div class="ui-g-12 p-zero mt-1" *ngFor="let reminder of reminders; let i = index">
              <app-review-reminders [showOrder]="false" [reminder]="reminder" [index]="i + 1" [isTimeOpen]="i===0"
                [sameLine]="false" [reviewSetting]="true" [dropDownPositionTop]="true" (deleteReminderItem)="deleteReminder($event)">
              </app-review-reminders>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="isMarketingEnabled" class="col-12 col-lg-{{isMarketingEnabled? '4': '6'}}">
        <app-dialog-follow-ups [isMarketingOptOutEnabled]="isMarketingOptOutEnabled" [estimate]="orderForFollowUp"
          (appHasFollowUps)="hasFollowUps = $event">
        </app-dialog-follow-ups>
      </div>
    </div>
  </div>

  <div class="ui-g-12 p-zero dialog-footer">
    <div class="flex-between-center">
      <div class="flex-start-center">
        <div id="review-customer-preview" class="customer-preview"
          *ngIf="customer && customer.customerId  && estimateId && paymentId" (click)="preview()">
          <i class="fal fa-clone"></i><span class="pl-2">Customer Preview</span>
        </div>
        <div id="review-customer-preview" class="customer-preview ml-3" *ngIf="paymentId"
          (click)="!isLoadingReceiptURL && downloadReceipt()">
          <i *ngIf="isLoadingReceiptURL" class="fal fa-spinner rotate"></i>
          <i class="fal fa-paperclip pl-1"></i><span class="pl-2">Reciept</span>
        </div>
      </div>
      <div class="flex-end-center">
        <input id="review-btn-cancel" type="button" value="Cancel"
          class="btn btn-white btn-border pointer btn-submit mr-1" (click)="close({})">

        <button id="review-btn-send" type="button" class="btn btn-primary btn-submit"
          [disabled]="!reviewAttach && !receiptAttach || isSending" (click)="onSubmit()">
          <i *ngIf="isSending" class="fal fa-spinner rotate mr-2"></i>
          <span>Send</span>
        </button>
        <!--
        <input value="Send" [disabled]="!reviewAttach && !receiptAttach || isSending" (click)="onSubmit()"
          class="btn btn-primary btn-submit"> -->
      </div>
    </div>
  </div>
</div>